import HotjarBrowser from '@hotjar/browser';

export const Hotjar = HotjarBrowser;
